import React, { useState } from 'react'

import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";
import '../../css/BisharatMain.css';
import { ENV_URL } from '../../services/Globals';
// import deafultImage from '../../data/images/logo.png';

const ImageSlider = ({ slides }) => {
    const [current, setCurrent] = useState(0)
    const length = slides.length;
  
    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1)
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1)
    };

    // if (!Array.isArray(slides) || slides.length <= 0) {
    //     return (
    //             <img className="image-default" src={deafultImage} alt="default-null" />
    //     );
    // }


    return (
        <section className="slider">
            <FaArrowAltCircleLeft className="left-arrow" onClick={prevSlide} />
            <FaArrowAltCircleRight className="right-arrow" onClick={nextSlide} />
            {slides.map((slide, index) => {
               
                return (

                    <div className={index === current ? 'slide-active' : 'slide'} key={index}>
                        {index === current && (
                            <div className="image-slider-desc">
                                {<img src={`${ENV_URL}/api/v1/images/${slide.id}/download`}
                                    alt="family"
                                    className="image" />}
                                <p className="description-image">{slide.description}</p></div>)}
                    </div>

                )
            })}
        </section>
    )
}

export default ImageSlider
